export default __webpack_public_path__ + "static/media/genome_bc.png";